<template>
  <section class="bio-section">
    <div class="container">
      <div class="bio-grid">
        <div class="bio-image-container animate-up delay-1">
          <div class="headshot-placeholder">
            <img
              src="@/assets/images/VipandeepSingh.png"
              alt="Vipandeep Headshot"
            />
          </div>
          <div class="experience-card">
            <h3>VIPANDEEP SINGH</h3>
            <p>Founder, Clients Preferred</p>
          </div>
        </div>

        <div class="bio-content animate-up delay-2">
          <span class="tag">EXCELLENCE & INTEGRITY</span>
          <h2>More Than Just a Real Estate Agent</h2>
          <p>
            Vipandeep Singh is a visionary entrepreneur, real estate advisor,
            and venture builder with a growing portfolio of businesses across
            multiple sectors. He is the founder of Clients Preferred Property
            Hub, a trust-driven real estate consultancy focused on verified,
            GMADA & RERA-approved projects across Tricity. With deep local
            market knowledge and a hands-on leadership approach, he helps
            homebuyers and investors make informed, future-ready decisions while
            simultaneously expanding ventures that align with transparency,
            quality, and credibility.
          </p>
          <p>
            Beyond real estate advisory, Vipandeep is actively building and
            scaling multiple ventures, driven by a strong belief in ethical
            business practices, long-term value creation, and customer-centric
            solutions. His entrepreneurial mindset allows him to see
            opportunities beyond transactions — focusing on systems,
            sustainability, and growth.
          </p>
          <p>
            For Vipandeep Singh, business is not just about growth — it’s about
            building trusted brands and lasting impact.
          </p>
          <div class="stats-grid">
            <div class="stat-item">
              <span class="number">100%</span>
              <span class="label">Client Focused</span>
            </div>
            <div class="stat-item">
              <span class="number">GTA</span>
              <span class="label">Expertise</span>
            </div>
          </div>

          <div class="contact-details">
            <a
              href="https://www.google.com/maps/search/?api=1&query=Gillco+Valley+Sector-127+Kharar+Mohali"
              target="_blank"
              class="contact-item link-item"
            >
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </span>
              <p>Gillco Valley Sector-127, Kharar, Mohali</p>
            </a>

            <a href="tel:+917087931778" class="contact-item link-item">
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
              </span>
              <p>Direct: +91-70879 31778</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.bio-section {
  padding: 80px 0;
}
.bio-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 80px;
  align-items: flex-start;
}
.bio-image-container {
  position: relative;
}
.headshot-placeholder img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 20px 20px 0 #f3f4f6;
  filter: grayscale(10%);
}
.experience-card {
  position: absolute;
  bottom: 20px;
  left: -20px;
  background: #b91c1c;
  color: white;
  padding: 20px 30px;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.experience-card h3 {
  font-size: 1.5rem;
  margin: 0;
}
.experience-card p {
  font-size: 0.8rem;
  margin: 0;
  letter-spacing: 1px;
}
.tag {
  color: #b91c1c;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 1.5px;
}
.bio-content h2 {
  font-size: 2.5rem;
  margin: 15px 0 25px;
  color: #111;
}
.bio-content p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 1.1rem;
}
.stats-grid {
  display: flex;
  gap: 40px;
  margin: 40px 0;
  padding: 30px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.stat-item .number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #b91c1c;
}
.stat-item .label {
  font-size: 0.9rem;
  color: #777;
  text-transform: uppercase;
}
.contact-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none; /* Ensure no underline on links */
  color: inherit; /* Maintain original text color */
}
.link-item {
  transition: all 0.3s ease;
}
.link-item:hover .icon {
  color: #b91c1c;
}
.link-item:hover p {
  color: #b91c1c;
}
.icon {
  display: flex;
  align-items: center;
  color: #777; /* Default icon color */
  transition: color 0.3s ease;
}
.contact-item p {
  margin: 0;
  font-weight: 600;
  transition: color 0.3s ease;
}

@media (max-width: 992px) {
  .bio-grid {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  .bio-image-container {
    max-width: 500px;
    margin: 0 auto;
  }
}
</style>
